module.exports = __webpack_public_path__ + "img/partial.8126e6b5.svg";